import { type FlightsResponse } from 'src/@types/reporting';
import axiosInstance from 'src/utils/axios';

const BASE_URL = 'reports';

interface GetMerchantEmployeeQueryParams {
  merchantCode: string;
  programmeCode?: string;
  emailAddress?: string;
  dateFrom?: string | null; // FIXME: Store in our own date object or luxon, but not string!
  dateTo?: string | null; // FIXME: Store in our own date object or luxon, but not string!
  pageSize?: number;
  pageNumber?: number;
  fields?: string[];
}

function getMerchantEmployeesApi(params: GetMerchantEmployeeQueryParams) {
  // FIXME: before sending off the request, make sure to format the dates in this function 
  // (it belongs here because sepcific date format depends on the endpoint)
  return axiosInstance.get(`${BASE_URL}/customers/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });
}

interface GetImpactStatsParams {
  merchantCode: string;
  programmeCode?: string;
  dateFrom?: string; // FIXME: Store in our own date object or luxon, but not string!
  dateTo?: string; // FIXME: Store in our own date object or luxon, but not string!

  // backend now handles the ownership type
  // ownershipType?: TransactionOwnershipType[];
}

function getImpactStatsApi(params: GetImpactStatsParams) {
  // FIXME: before sending off the request, make sure to format the dates in this function 
  // (it belongs here because sepcific date format depends on the endpoint)
  return axiosInstance.get(`${BASE_URL}/impact/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });
}

interface GenericStatsParams {
  merchantCode?: string;
  programmeCode: string;
  dateFrom: string; // FIXME: Store in our own date object or luxon, but not string!
  dateTo: string; // FIXME: Store in our own date object or luxon, but not string!
  page?: number;
  size?: number;
}

function getAviationStatsApi(params: GenericStatsParams) {
  // FIXME: before sending off the request, make sure to format the dates in this function 
  // (it belongs here because sepcific date format depends on the endpoint)
  return axiosInstance.get(`${BASE_URL}/aviation/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });
}

function getJourneyStatsApi(params: GenericStatsParams) {
  // FIXME: before sending off the request, make sure to format the dates in this function 
  // (it belongs here because sepcific date format depends on the endpoint)
  return axiosInstance.get(`${BASE_URL}/journey/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });
}



function getFlightsApi(params: GenericStatsParams): Promise<FlightsResponse> {
  return axiosInstance.get(`${BASE_URL}/aviation/v1/flights`, {
    params,
    paramsSerializer: { indexes: null },
  });
}

export { getMerchantEmployeesApi, getImpactStatsApi, getAviationStatsApi, getJourneyStatsApi, getFlightsApi };
